export const ExhibitionsGalleryIMAGES = {
    "hgh-exhibition": {
        Meta_title: 'HGH Exhibition | Marvel Blinds',
        Meta_OG_description: "HGH Exhibition HGH India, the annual trade show for home textiles, home decor, houseware and gifts. This trade show designed exclusively to connect its exhibitors with the Indian retail trade, distribution channels, brand representatives.",
        canonical_OG_url: `${process.env.REACT_APP_WEBSITE_URL}/Exhibitions/hgh-exhibition`,
        pg_title: 'HGH Exhibition',
        pg_des: 'HGH India, the annual trade show for home textiles, home decor, houseware and gifts. This trade show designed exclusively to connect its exhibitors with the Indian retail trade, distribution channels, brand representatives.',
        images: [
            "/Assets/Exhibitions/hgh1-1.jpg",
            "/Assets/Exhibitions/hgh2-1.jpg",
            "/Assets/Exhibitions/hgh3-1.jpg",
            "/Assets/Exhibitions/hgh4-1.jpg",
            "/Assets/Exhibitions/hgh5-1.jpg",
            "/Assets/Exhibitions/hgh6-1.jpg",
            "/Assets/Exhibitions/hgh7-1.jpg",
            "/Assets/Exhibitions/hgh8-1.jpg",
            "/Assets/Exhibitions/hgh9-1.jpg",
            "/Assets/Exhibitions/hgh10-1.jpg",
            "/Assets/Exhibitions/hgh11-1.jpg",
            "/Assets/Exhibitions/hgh12-1.jpg",
            "/Assets/Exhibitions/hgh13-1.jpg",
            "/Assets/Exhibitions/hgh14-1.jpg",
            "/Assets/Exhibitions/hgh15-1.jpg",
            "/Assets/Exhibitions/hgh16-1.jpg",
        ]
    },
    "ace-tech": {
        Meta_title: 'ACE Tech | Marvel Blinds',
        Meta_OG_description: "ACE Tech Exhibition – Mumbai HGH India, the annual trade show for home textiles, home decor, houseware and gifts. This trade show designed exclusively to connect its exhibitors with the Indian retail trade, distribution channels, brand representatives.",
        canonical_OG_url: `${process.env.REACT_APP_WEBSITE_URL}/Exhibitions/ace-tech`,
        pg_title: 'ACE Tech Exhibition – Mumbai',
        pg_des: 'ACETECH is a leading trade fair in Asia for architecture, building materials, innovation and design and only third-of-its-kind in the world. This unique forum offers opportunities to not just exhibit but also to create a long-lasting impression on the decision makers of the architecture, building materials, innovation and design industries.',
        images: [
            "/Assets/Exhibitions/acetech1.jpg",
            "/Assets/Exhibitions/acetech2.jpg",
            "/Assets/Exhibitions/acetech3.jpg",
            "/Assets/Exhibitions/acetech4.jpg",
            "/Assets/Exhibitions/acetech5.jpg",
            "/Assets/Exhibitions/acetech6.jpg",
            "/Assets/Exhibitions/acetech7.jpg",
            "/Assets/Exhibitions/acetech8.jpg",
        ]
    },
    "index-mumbai": {
        Meta_title: 'Index Mumbai | Marvel Blinds',
        Meta_OG_description: "Index- Mumbai Index is a leading international trade fair and India’s largest focused commercial platform on interiors, architecture and design, bringing together suppliers and buyers in a design atmosphere.The industry has grown, new and big international players have entered the markets, and the scope for doing business has evolved with both exhibitors and organizers becoming […]",
        canonical_OG_url: `${process.env.REACT_APP_WEBSITE_URL}/Exhibitions/index-mumbai`,
        pg_title: 'Index- Mumbai',
        pg_des: "Index is a leading international trade fair and India's largest focused commercial platform on interiors, architecture and design, bringing together suppliers and buyers in a design atmosphere.The industry has grown, new and big international players have entered the markets, and the scope for doing business has evolved with both exhibitors and organizers becoming more professional.",
        images: [
            "/Assets/Exhibitions/index1-1.jpg",
            "/Assets/Exhibitions/index2-1.jpg",
            "/Assets/Exhibitions/index3-1.jpg",
            "/Assets/Exhibitions/index4-1.jpg",
            "/Assets/Exhibitions/index5-1.jpg",
            "/Assets/Exhibitions/index6-1.jpg",
            "/Assets/Exhibitions/index7-1.jpg",
            "/Assets/Exhibitions/index8-1.jpg",
        ]
    }
}